export const BASE_URL = import.meta.env.BASE_URL ?? "/";
export const BUILD_TARGET = import.meta.env.VITE_BUILD_TARGET ?? "dev";
export const DEBUGS =
  (import.meta.env.VITE_DEBUGS ?? "false").toLowerCase() === "true";

export const PRODUCT_API_BASE_URL =
  import.meta.env.VITE_AMITY_PRODUCT_API ?? "";
export const SERVICE_API_BASE_URL =
  import.meta.env.VITE_AMITY_SERVICE_API ?? "";

export const BYPASS_CHECK_MAPPING_STATUS =
  (
    import.meta.env.VITE_BYPASS_CHECK_MAPPING_STATUS ?? "false"
  ).toLowerCase() === "true";

export const GRAB_WEB_ORIGIN_URL = import.meta.env.VITE_GRAB_WEB_ORIGIN_URL;
export const GRAB_APP_REDIRECT_URL = import.meta.env.VITE_GRAB_APP_REDIRECT_URL;
export const GRAB_HELP_CENTER_URL = import.meta.env.VITE_GRAB_HELP_CENTER_URL;

export const LINE_LIFF_OPT_IN = import.meta.env.VITE_LINE_LIFF_OPT_IN;
export const LINE_LIFF_OPT_OUT = import.meta.env.VITE_LINE_LIFF_OPT_OUT;

export const LINE_AUTHORIZE_URL = import.meta.env.VITE_LINE_ACCESS;
export const LINE_AUTHORIZE_CLIENT_ID = import.meta.env
  .VITE_LINE_LOGIN_CHANNEL_ID;
export const LINE_AUTHORIZE_REDIRECT_URL = import.meta.env
  .VITE_LINE_LOGIN_REDIRECT_URL;
export const LINE_AUTHORIZE_SCOPE = import.meta.env.VITE_LINE_LOGIN_SCOPE;

export const LINE_MESSAGE_CHANNEL_ID = import.meta.env
  .VITE_LINE_MESSAGE_CHANNEL_ID;

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_ENV = import.meta.env.VITE_SENTRY_ENVIRONMENT;
export const SENTRY_IS_TRIGGER_EVENT =
  (import.meta.env.VITE_SENTRY_IS_TRIGGER_EVENT ?? "true").toLowerCase() ===
  "true";
